import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { type ReactElement, useEffect } from 'react';

import { get } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import { SettingLayout } from '../../../../../FSD/shared/ui/layout/SettingLayout';
import DeviceManagementPage from '../../../../../components/pages/my/settings/device/DeviceManagementPage';

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60,
});

export default function DeviceManagement() {
  useEffect(function preventBFCache() {
    /**
     * 민감한 정보들을 BFCache로부터 사용하지 않게하기 위함
     * 참고: https://web.dev/i18n/ko/bfcache/#bfcache-5
     *
     * pageshow 이벤트는 페이지가 처음 로드될 때와 페이지가 bfcache에서 복원될 때 load 이벤트 직후에 발생
     */
    window.addEventListener('pageshow', (event) => {
      const navigation = performance.getEntriesByType('navigation');
      const navigateBy = get(navigation[0], 'type');
      if (event.persisted || navigateBy === 'back_forward') {
        location.reload();
      }
    });
  }, []);

  return <DeviceManagementPage />;
}

function DeviceManagementLayout({ children }: { children: ReactElement }) {
  const { t } = useTranslation();
  return (
    <SettingLayout
      title={t('메타.기기관리.제목')}
      description={t('메타.기기관리.설명')}
      pageCategory={t('계정')}
    >
      {children}
    </SettingLayout>
  );
}

DeviceManagement.getLayout = (page: ReactElement) => (
  <DeviceManagementLayout>{page}</DeviceManagementLayout>
);
